// *** GLOBAL FUNCTIONS ***

const foundGroup = (id) => {
    const group = document.querySelectorAll(id);
    return group;
}

const animations = (time, className) => {
    const group = document.querySelectorAll(className);
    group.forEach(element => {
        setTimeout(() => {
            getTransformOrigin(element);
            StartAnimation(element);
        }, time += 500);
    })
}

const getTransformOrigin = element => {
    const width = element.getBoundingClientRect().width;
    const height = element.getBoundingClientRect().height;

    let coordX = width/2
    let coordY = height/2 
    if (element.classList.contains("toScale")) {
        if (element.classList.contains('group_1')) {
            element.style.transformOrigin = "50% 50%";
            return;
        }
        element.style.transform = 'scale(0)';
        
        if (!element.classList.contains('group-home')) {
            coordX = parseInt(coordX) + parseInt(element.getAttribute('x'));
            coordY = parseInt(coordY) + parseInt(element.getAttribute('y'));
        }
        element.style.transformOrigin = coordX +'px ' + coordY + 'px';
    }

}

const StartAnimation = (element, delay, pageWithDelay) => {
    if (pageWithDelay) {
        if (delay !== undefined) {
            element.style.animationDelay = delay + 'ms';
        } 
        if (element.classList.contains("hide")) {
            element.classList.replace('hide', 'appeard');
        } 
        if (element.classList.contains('toScale')) {
            element.classList.replace('toScale', 'pop');
        }
    } else {
        if (element.classList.contains('hide')) {
            element.classList.replace('hide', 'appeard');
        }
        if (element.classList.contains('toScale')) {
            element.classList.replace('toScale', 'pop');
        }   
        
        if (element.classList.contains('fromTopOff')) {
            element.style.animationDelay = delay + 'ms';
            element.classList.replace('fromTopOff', 'fromTopOn');
        }
    }
}

const SVGAnimation = (time, groups, page) => {
    for (let group of groups) {
        setTimeout(() => {
            const groupElement = foundGroup(group.id);
            let delay = 0;
            groupElement.forEach(element => {
                delay += group.delay;
                getTransformOrigin(element);
                StartAnimation(element, delay, page);
            })
        }, time += group.time);
    }
}

const removeClass = element => {
    if (element.classList.contains('animated')) {
        element.classList.add('visited');
    }
    if (element.classList.contains('hide')) {
        element.classList.remove('hide');
    }
    if (element.classList.contains('toScale')) {
        element.classList.remove('toScale');
    }   
    
    if (element.classList.contains('fromTopOff')) {
        element.classList.remove('fromTopOff');
    }
}

const removeAnimation = className => {
    const group = document.querySelectorAll(className);

    group.forEach(element => {
        removeClass(element)
    })
}

const removeSVGAnimation = groups => {
    for (let group of groups) {
        const groupElement = foundGroup(group.id);

        groupElement.forEach(element => {
            removeClass(element);
        }) 
    }
}

export { StartAnimation, getTransformOrigin, animations, foundGroup, SVGAnimation, removeAnimation, removeSVGAnimation };